export { default } from '@shikijs/langs/ruby'
